import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';

import ProductOverviewSubscriptionShield from './ProductOverviewSubscriptionShield';
import ProductOverviewTitle from './ProductOverviewTitle';
import ProductOverviewStatusInfo from './ProductOverviewStatusInfo';
import GdsnShield from 'pages/home/ribbon/components/controls/product-full/GdsnShield';

import { useCheckAllowEditProducts } from 'hooks';

const ProductPrimaryInfo = ({
  product,
  originProduct,
  refPrimaryInfo,
  ...rest
}) => {
  const {
    isHierarchy,
    statusWidth,
    setEditProductId,
    isFixPublicationErrorView,
  } = rest;

  const { checkAllowEditProductFull } = useCheckAllowEditProducts();
  const isAllowEditProduct = checkAllowEditProductFull(product);

  // Hide the GDSN shield when the product is received from GDSN (green) and it
  // is already subscribed/syndicated — the subscription shield represents it.
  // Only hide it when the subscription shield is actually displayed, otherwise
  // both shields would disappear.
  const showSubscriptionShield = !isAllowEditProduct && !!product?.subscriptionShield;
  const subscriptionShieldStatus = product?.subscriptionShield?.toLowerCase();
  const gdsnShieldColour = product?.gdsnShield?.toLowerCase();
  const hideGdsnShield =
    showSubscriptionShield &&
    gdsnShieldColour === 'green' &&
    (subscriptionShieldStatus === 'subscribed' ||
      subscriptionShieldStatus === 'syndicated');

  // When the product is received from GDSN and modified (yellow shield) and it
  // is subscribed, hide the subscription shield — the yellow GDSN shield
  // represents it.
  const hideSubscriptionShield =
    gdsnShieldColour === 'yellow' && subscriptionShieldStatus === 'subscribed';

  return (
    <Row className='product-overview' align='middle' ref={refPrimaryInfo}>
      {!isAllowEditProduct &&
        product?.subscriptionShield &&
        !hideSubscriptionShield && (
          <Col>
            <ProductOverviewSubscriptionShield product={product} />
          </Col>
        )}

      {product?.gdsnShield && !hideGdsnShield && (
        <Col>
          <GdsnShield gdsnShield={product?.gdsnShield} />
        </Col>
      )}

      <Col style={{ width: 'calc(100% - 180px)' }}>
        <ProductOverviewTitle
          product={product}
          originProduct={originProduct}
          isHierarchy={isHierarchy}
          isFixPublicationErrorView={isFixPublicationErrorView}
          setEditProductId={setEditProductId}
        />
      </Col>
      <Col flex={statusWidth ? `${statusWidth}px` : '180px'}>
        <ProductOverviewStatusInfo data={product} />
      </Col>
    </Row>
  );
};

ProductPrimaryInfo.propTypes = {
  product: PropTypes.object,
};

export default ProductPrimaryInfo;
